// React
import { useState, useCallback, useContext } from 'react';

// Components
import Thumbnail from '../Thumbnail/Thumbnail';

// Global Context
import { GlobalContext } from '../../../contexts/Global';

// Styles
import "./Uploader.scss";
import "../Signature/Signature.scss";

const Uploader = (props) => {
    const {
        className,
        name,
        value,
        onChange,
        maxFiles = 10
    } = props;

    const [ files, setFiles ] = useState(value && value.length > 0 ? value : [])
    const { user } = useContext(GlobalContext);

    const handleChange = useCallback((e) => {
        if (e.target.files.length > 0) {
            setFiles([
                ...files,
                e.target.files[0]
            ]);

            onChange({
                value: [
                    ...files,
                    e.target.files[0]
                ]
            });
        }
    }, [ onChange, files ]);

    const removeFile = (index) => {
        if (files[index].constructor.name == 'File') {
            const newFiles = files.filter((file, i) => i !== index);
            setFiles(newFiles);

            onChange({
                value: newFiles
            });
        }
        else {
            const newFiles = files.map((file, i) => {
                if (i === index) {
                    return {
                        ...file,
                        is_deleted: true
                    }
                }
                else {
                    return file;
                }
            });

            setFiles(newFiles);

            onChange({
                value: newFiles
            });
        }
    }

    const openFile = async (file) => {
        try {
            const response = await fetch(file.url_hi_res, {
                headers: {
                    'Authorization': `Bearer ${user.access_token}`
                }
            });

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        }
        catch (error) {
            console.error('Error fetching protected resource:', error);
        }
    }

    return (
        <div className={ 'uploader ' + className }>
            { files.length > 0 && files.map((file, index) =>
                <div key={ index } className={ 'thumbnail' + (file instanceof Object && file.is_deleted === true ? ' hidden' : '') }>
                    <Thumbnail file={ file } />
                    <div className="close" onClick={ () => removeFile(index) }>
                        <span className="k-icon k-font-icon k-i-x"></span>
                    </div>
                    { !(file instanceof File) && file.url_hi_res &&
                        <div className="open" onClick={ () => openFile(file) }>
                            <span className="k-icon k-font-icon k-i-x-outline k-i-hyperlink-open-sm"></span>
                        </div>
                    }
                </div>
            )}
            { files.length < maxFiles &&
                <div className="add-button">
                    <div className="plus">+</div>
                    <input name={ name } type="file" onChange={ handleChange } />
                </div>
            }
        </div>
    );
};

export default Uploader;
